/**
 * From-address shown in magic-link "check your email" copy. Must match the
 * sender configured in Firebase Console → Authentication → Templates → SMTP
 * (Resend: noreply@mail.ecointel.io). Override per build via REACT_APP_AUTH_EMAIL_SENDER.
 */
export const AUTH_MAGIC_LINK_SENDER =
  process.env.REACT_APP_AUTH_EMAIL_SENDER || 'noreply@mail.ecointel.io';
